"use client";

import { Button } from "@/components/ui/button";
import {
	Dialog,
	DialogBody,
	DialogContent,
	DialogFooter,
	DialogHeader,
	DialogTitle,
} from "@/components/ui/dialog";
import { useStoragePersistence } from "@/services/storage/use-storage-persistence";
import { useTranslations } from "next-intl";

export function StoragePersistenceDialog() {
	const t = useTranslations("ProjectDialogs");
	const { showDialog, onConfirm, onDismiss } = useStoragePersistence();

	return (
		<Dialog open={showDialog} onOpenChange={(open) => !open && onDismiss()}>
			<DialogContent className="sm:max-w-md">
				<DialogHeader>
					<DialogTitle>{t("storage.title")}</DialogTitle>
				</DialogHeader>
				<DialogBody>
					<p className="text-base text-muted-foreground">
						{t("storage.description")}
					</p>
					<p className="text-base text-muted-foreground">
						{t("storage.question")}
					</p>
				</DialogBody>
				<DialogFooter>
					<Button variant="outline" onClick={onDismiss}>
						{t("storage.notNow")}
					</Button>
					<Button onClick={onConfirm}>{t("storage.allow")}</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
}
